import styled from 'styled-components';

const Hero = styled.div`
    width: 100%;
    flex: 1 0 0%;
    background-image: url(${props => props.imgSrc});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const Text = styled.span`
    font-size: ${props => props.theme.font.xxxlrg};
    line-height: ${props => props.theme.font.xxxlrg};
    font-weight: 700;
    color: white;
    text-align: center;
    filter: drop-shadow(0 0 5px #0003)
`;

Hero.Text = Text;
export { Hero };



// WEBPACK FOOTER //
// ./src/sc-ui/Hero.jsx